module.exports = __webpack_public_path__ + "static/media/feature-search-advanced@2x.33131c25.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/feature-search-advanced@2x.png
// module id = 168
// module chunks = 0